export const APPOINTMENT = {
  APPOINTMENT_FORM: {
    LABELS: {
      FIRST_NAME: 'First name',
      LAST_NAME: 'Last Name',
      EMAIL: 'Email',
      PHONE: 'Phone',
      CLINIC: 'Location',
      SERVICE: 'Requested Service',
      PROVIDER: 'Provider',
      APPOINTMENT_STATUS: 'Appointment Status',
      APPOINTMENT_MODE: 'Appointment Type',
      APPOINTMENT_DATE: 'Appointment Date',
      TIME: 'Appointment Time',
      NOTES: 'Notes',
    },
    PLACEHOLDERS: {
      FIRST_NAME: 'First name',
      LAST_NAME: 'Last name',
      EMAIL: 'name@example.com',
      PHONE: '(123) 456-7890',
      CLINIC: 'Select a location',
      SERVICE: 'Select a service',
      PROVIDER: 'Select a provider',
      APPOINTMENT_STATUS: 'Select a status',
      APPOINTMENT_MODE: 'Select appointment type',
      APPOINTMENT_DATE: 'Select a date',
      TIME_SLOT: 'Select a time',
    },
    BUTTONS: {
      ADD: 'Add Appointment',
      SAVE: 'Save Changes',
    },
    TOAST_MESSAGES_SUCCESS: {
      CREATE_APPOINTMENT: 'Appointment Created Successfully',
      UPDATE_APPOINTMENT: 'Appointment Updated Successfully',
    },
    TOAST_MESSAGES_ERRORS: {
      LOAD_SERVICES: 'Failed to Load the Services',
      LOAD_PROVIDERS: 'Failed to load the provider List',
      LOAD_DATES: 'Failed to Load the Dates',
      LOAD_TIMES: 'Failed to Load the Time Slots',
      LOAD_CLINICS: 'Failed to Load Clinics',
      LOAD_DETAILS: 'Failed to fetch appointment details.',
      CREATE_APPOINTMENT: 'Failed Create Appointment',
      UPDATE_APPOINTMENT: 'Failed to Update Appointment',
    },
  },

  APPOINTMENT_LISTING: {
    LABELS: {
      ROWS_SELECTED: 'rows selected',
      ROW_SELECTED: 'row selected',
      TITLE: 'Appointments',
      UPDATED_AT: 'appointmentUpdatedDate',
      LOAD_APPOINTMENTS: 'Loading appointments...',
      DELETE_SELECTED_APPOINTMENT: 'Delete Selected Appointment',
      FILTERS: 'Filters',
      CLINICS: 'Clinics',
      SERVICES: 'Services',
      PROVIDERS: 'Providers',
      DATES: 'Dates',
    },
    BUTTONS: {
      ADD: 'Add Appointment',
      EDIT: 'Edit Appointment',
      APPLY: 'Apply',
      CANCEL: 'Cancel',
    },
    PLACEHOLDERS: {
      SEARCH:
        'Search by contact name, email, phone number, or appointment ID...',
      CLINIC: 'Select Clinic',
      SERVICE: 'Select Service',
      PROVIDER: 'Select Provider',
    },
    TOAST_MESSAGES_SUCCESS: {
      DELETE_APPOINTMENT: 'Appointment Deleted Successfully',
      EXCEL_FILE: 'Excel file exported successfully.',
      PDF_FILE: 'PDF file exported successfully.',
    },
    TOAST_MESSAGES_ERRORS: {
      DELETE_APPOINTMENT: 'Failed to Delete Appointment',
      EXPORT_APPOINTEMENTS: 'Unable to export appointments',
      LOAD_DATA: 'Failed to Load the Data',
      NO_DATA: 'No data available for export.',
    },
  },
};
